export default __webpack_public_path__ + "static/till-carlos_bigcircle-c9f33724e425365b3fde780ffeb30493.png";